import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Button } from 'components/Buttons/Button';

import './AddToBagButton.scss';

interface AddToBagButtonProps {
  addToCartLabel: string;
  addToCartHoverLabel: string;
  addToCartTooltipLabel?: string;
  onAddToCart: () => void;
  isAddToCartLoading?: boolean;
}

const AddToBagButton: React.FC<AddToBagButtonProps> = ({
  onAddToCart,
  isAddToCartLoading,
  addToCartLabel,
  addToCartHoverLabel,
  addToCartTooltipLabel,
}) => {
  const [isHover, setHover] = useState(false);
  const handleMouseEnter = () => {
    setHover(true);
  };
  const handleMouseLeave = () => {
    setHover(false);
  };
  const handleAddToBag = () => {
    onAddToCart?.();
  };
  return (
    <Tooltip title={addToCartTooltipLabel} placement="top" arrow>
      <Button
        className="addToBagButton"
        disabled={isAddToCartLoading}
        size="medium"
        variant="contained"
        onClick={handleAddToBag}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        startIcon="cart-material"
        data-cnstrc-btn="add_to_cart"
      >
        {isHover && addToCartHoverLabel ? addToCartHoverLabel : addToCartLabel}
      </Button>
    </Tooltip>
  );
};

export { AddToBagButton };
